import LokaliseMarkdownText from "@whoppah/components/text/LokaliseMarkdownText";
import SEO from "../common/seo";
import { useTranslation } from "next-i18next";

const Terms = () => {
  const { t } = useTranslation();
  return (
    <>
      <SEO title={t("terms:terms-title")} />
      <LokaliseMarkdownText
        lokaliseKey="terms:terms-content"
        className="flex flex-col gap-4 p-[8px] md:p-[64px]"
      />
    </>
  );
};

export default Terms;
